export class URN {
  urn?: string;
  identifier?: string;
}